import useApiCall from "@hooks/Shared/useApiCall";
import { IGatingSystem } from "@interfaces/GatingSystem/GatingSystem";

const useGetGatingSystem = (projectId: string) =>
  useApiCall<IGatingSystem>({
    url: `/projects/${projectId}/gating-system/`,
  });

export default useGetGatingSystem;
